import { render } from "./add-products.vue?vue&type=template&id=4f5d5f56"
import script from "./add-products.vue?vue&type=script&lang=js"
export * from "./add-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__